import { h } from 'preact';

export function IconChevronRightNarrow({ width = 22, height = 50, fill = 'currentColor' }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 22 50"
      width={width}
      height={height}
      class="icon-chevron-right-narrow"
    >
      <path
        d="M0.659279 3.63644L16.682 24.9994L0.659279 46.3636C-0.0939452 47.3678 0.109766 48.7924 1.11387 49.5454C2.11797 50.2986 3.54268 50.0948 4.29571 49.0908L21.341 26.363C21.947 25.555 21.947 24.4438 21.341 23.6358L4.29561 0.90919C3.84913 0.313778 3.16671 -9.2745e-05 2.47559 -9.2745e-05C2.00118 -9.2745e-05 1.52256 0.148056 1.11377 0.454599C0.109573 1.20782 -0.0939452 2.63234 0.659279 3.63644Z"
        fill={fill}
      />
    </svg>
  );
}
